module.exports = __webpack_public_path__ + "static/media/IMG_032.8dea421a.JPG";